import React from "react";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const PasswordResetLink = ({
  id,
  isPasswordResetLinkOpen,
  closePasswordResetLink,
  customer,
}) => {
  return (
    <SmallSlidePanel
      isOpen={isPasswordResetLinkOpen}
      onClose={closePasswordResetLink}
      showCloseButton={true}
      width={520}
    >
      <div id={id} className="bg-white">
        <div className="mb-10 mx-auto items-center justify-center">
          <div className="w-full flex flex-col items-center mt-5">
            <svg
              width="53"
              height="53"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="53" height="53" rx="26.5" fill="#BFDFFD" />
              <path
                d="M11 32L20.7544 38.7761L39.43 17.9347"
                stroke="#074073"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>

            <p className="items-center text-center font-[600] text-[16px] mt-5">
              Password Reset Link Sent
            </p>

            <p className="items-center text-center font-[400] text-[16px] mt-3">
              A password reset link has been sent to
            </p>

            <p className="items-center text-center font-[400] text-[16px]">
              {customer?.email}
            </p>
          </div>
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default PasswordResetLink;
